export const getRemainingTrialDays = (trialEndsAt: Date): number => {
    const now = new Date();
    const diff = trialEndsAt.getTime() - now.getTime();
    return Math.ceil(diff / (1000 * 3600 * 24));
}